import { gql } from '__generated__';

export default gql(`
  query GetClaimedRegistration($event_id: ID!) {
    event(id: $event_id) {
      ...EventFields
    }
  }
`);
